import { Mutation } from 'vuex';
import { IModuleState } from './types';

// 主词典列表
export const setDictMainList: Mutation<IModuleState> = (state, payload) => {
  state.mainList.data = payload.data;
  state.mainList.loading = !!payload.loading;
};

// 停止词列表
export const setDictStopList: Mutation<IModuleState> = (state, payload) => {
  state.stopList.data = payload.data;
  state.stopList.loading = !!payload.loading;
};

// 同义词列表
export const setDictSynonymList: Mutation<IModuleState> = (state, payload) => {
  state.synonymList.data = payload.data;
  state.synonymList.loading = !!payload.loading;
};

// 搜索分词
export const setDictSchList: Mutation<IModuleState> = (state, payload) => {
  state.schList.data = payload.data;
  state.schList.loading = !!payload.loading;
};

// 文档分词
export const setDictDocList: Mutation<IModuleState> = (state, payload) => {
  state.docList.data = payload.data;
  state.docList.loading = !!payload.loading;
};

// 同义词检查
export const setDictCheckList: Mutation<IModuleState> = (state, payload) => {
  state.checkList.data = payload.data;
  state.checkList.loading = !!payload.loading;
  state.checkList.success = !!payload.success;
};

// 同义词弹窗
export const setDialog: Mutation<IModuleState> = (state, payload) => {
  state.dialog.active = payload.active;
  state.dialog.title = payload.title;
  state.dialog.visible = !!payload.visible;
  state.dialog.loading = !!payload.loading;
};

// 确认弹窗
export const setConfirm: Mutation<IModuleState> = (state, payload) => {
  state.confirm.active = payload.active;
  state.confirm.title = payload.title;
  state.confirm.content = payload.content;
  state.confirm.visible = !!payload.visible;
  state.confirm.loading = !!payload.loading;
};

export const setLoading: Mutation<IModuleState> = (state, payload) => {
  state.loading = !!payload;
};
